import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { imageUrl } from '../../api/api';
import { UserCircleIcon, ArrowLeftIcon } from '@heroicons/react/24/solid';
import { useTheme } from '../../ThemeContext';
import { assignTask, getTask, deleteTask, updateTask, getSingleUser } from '../../api/api';
import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import ConfirmationModal from '../ConfirmationModal';
const UserDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data } = location.state || {};
  const { UserId } = location.state || "";
  const { theme } = useTheme();
  const [showTaskModal, setShowTaskModal] = useState(false);
  const [task, setTask] = useState({ taskName: '', taskStatus: '', duration: '' });
  const [edit, setEdit] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [id, setId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [taskToDelete, setTaskToDelete] = useState(null);
  const [user, setUser] = useState({});
  const [error, setError] = useState({ userError: false, taskError: false });
//console.log(task)
  const isDarkMode = theme === 'dark';

  const handleEditTask = (task) => {
    setShowTaskModal(true);
    setEdit(true);
    setId(task._id);
    setTask({
      taskName: task.task_name,
      taskStatus: task.task_status,
      duration: task.duration,
    });
  };

  const handleAssignTask = () => {
    setShowTaskModal(true); // Show the modal for assigning a task
    setEdit(false); // Ensure the modal is in "add" mode, not "edit"
    setTask({ taskName: '', taskStatus: '', duration: '' }); // Reset task fields
  };

  const handleCloseModal = () => {
    setShowTaskModal(false);
  };
//console.log(tasks)
  const fetchTasks = async () => {
    try {
      const res = await getTask(user._id);
      if (res?.data?.length > 0) {
        setTasks(res.data);
        setError((prev) => ({ ...prev, taskError: false }));
      } else {
        setTasks([]);
        setError((prev) => ({ ...prev, taskError: true }));
      }
    } catch (err) {
      console.error('Error fetching tasks:', err);
      setTasks([]);
      setError((prev) => ({ ...prev, taskError: true }));
    }
  };

  useEffect(() => {
    if (UserId) {
      const fetchUser = async () => {
        try {
          const res = await getSingleUser(UserId);
          if (res?.data) {
            setUser(res.data);
            setError((prev) => ({ ...prev, userError: false }));
          } else {
            setUser({});
            setError((prev) => ({ ...prev, userError: true }));
          }
        } catch (err) {
          console.error('Error fetching user details:', err);
          setUser({});
          setError((prev) => ({ ...prev, userError: true }));
        }
      };
      fetchUser();
    } else {
      setUser(data || {});
    }
  }, [UserId]);

  useEffect(() => {
    fetchTasks();
  }, [task, edit]);
console.log(user)
  const handleTaskSubmit = async (e) => {
    e.preventDefault();
    const taskData = {
      user_id: user._id,
      task_name: task.taskName,
      task_status: task.taskStatus,
      duration: task.duration,
    };

    try {
      if (edit) {
        await updateTask({ id, data: taskData });
        setEdit(false);
      } else {
        await assignTask(taskData);
      }
      setShowTaskModal(false);
      fetchTasks();
    } catch (err) {
      console.error('Error submitting task:', err);
    }
  };

  const handleDeleteTaskClick = (taskId) => {
    setTaskToDelete(taskId);
    setShowDeleteModal(true);
    console.log("clicked")
  };

  const confirmDeleteTask = async () => {
    try {
      await deleteTask(taskToDelete);
      setShowDeleteModal(false);
      setTaskToDelete(null);
      fetchTasks();
    } catch (err) {
      console.error('Error deleting task:', err);
    }
  };

  return (
    <div
      className={`flex flex-col items-center w-full min-h-screen p-4 ${isDarkMode ? 'bg-gradient-to-br from-gray-800 to-gray-900' : 'bg-gradient-to-br from-gray-50 to-gray-200'}`}
    >
      <div className="flex justify-between w-full mb-6">
        <button onClick={() => navigate('/Users')} className="flex items-center text-blue-600 hover:text-blue-700">
          <ArrowLeftIcon className="w-5 h-5 mr-1" />
          Users
        </button>
        <button onClick={handleAssignTask} className="px-4 py-2 bg-blue-600 text-white rounded-full hover:bg-blue-700">
          Assign Task
        </button>
      </div>

      <div className={`w-full p-8 rounded-lg shadow ${isDarkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'}`}>
        <div className="flex flex-col items-center mb-8">
          <UserCircleIcon className={`w-24 h-24 mb-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-400'}`} />
          <h1 className="text-3xl font-semibold">User Details</h1>
          {error.userError ? (
            <p className="text-red-500">No user data available.</p>
          ) : (
            <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Detailed information about the user</p>
          )}
        </div>

        {!error.userError && (
          <div className="space-y-4">
            {[{ label: 'Name', value: user?.name }, { label: 'Email', value: user?.email }, { label: 'Phone', value: user?.contact_no }, { label: 'Authority', value: user?.authority }, { label: 'Resume', value: <a href={`${imageUrl}/${user?.resume}`} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 underline">View Resume</a> },].map(({ label, value }) => (
              <div key={label} className={`flex justify-between items-center border-b pb-3 ${isDarkMode ? 'border-gray-600' : 'border-gray-200'}`}>
                <span className={`text-base font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>{label}:</span>
                <span className={`text-base font-semibold ${isDarkMode ? 'text-gray-200' : 'text-gray-800'}`}>{value}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {error.taskError ? (
        <p className="mt-6 text-red-500">No tasks available.</p>
      ) : (
        tasks.length > 0 && (
          <div className="w-full mt-6">
            <h2 className="text-2xl font-semibold mb-4">Tasks</h2>
            <table className="w-full table-auto border-collapse">
              <thead>
                <tr className={`text-left ${isDarkMode ? 'bg-gray-700 text-gray-200' : 'bg-gray-100 text-gray-900'}`}>
                  <th className="py-2 px-4 border-b">Task Name</th>
                  <th className="py-2 px-4 border-b">Status</th>
                  <th className="py-2 px-4 border-b">Duration</th>
                  <th className="py-2 px-4 border-b">Action</th>
                </tr>
              </thead>
              <tbody>
                {tasks.map((task, index) => (
                  <tr key={index} className={isDarkMode ? 'bg-gray-800 text-gray-300' : 'bg-white text-gray-800'}>
                    <td className="py-2 px-4 border-b">{task.task_name}</td>
                    <td className="py-2 px-4 border-b">
                      <span
                        className={`text-sm font-medium ${task.task_status === 'Complete' ? 'text-green-500' : task.task_status === 'In_Progress' ? 'text-cyan-500' : 'text-red-400'}`}
                      >
                        {task.task_status}
                      </span>
                    </td>
                    <td className="py-2 px-4 border-b">{task.duration} days</td>
                    <td className="py-2 px-4 border-b">
                      <div className="flex space-x-2">
                        <button onClick={() => handleEditTask(task)} className="text-blue-600 hover:text-blue-700">
                          <PencilIcon className="w-5 h-5" />
                        </button>
                        <button
                          onClick={() =>
                            console.log("delete clicked") || handleDeleteTaskClick(task._id)
                          }
                          className="text-red-600 hover:text-red-700"
                        >
                          <TrashIcon className="w-5 h-5" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}

      <ConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={confirmDeleteTask}
        title="Delete Task"
        message="Are you sure you want to delete this task?"
      />

{showTaskModal && (
  <div
    className={`fixed inset-0 flex justify-center items-center ${isDarkMode ? 'bg-gray-900 bg-opacity-70' : 'bg-gray-700 bg-opacity-50'}`}
    onClick={handleCloseModal}
  >
    <div
      className={`${
        isDarkMode ? 'bg-gray-800 text-white' : 'bg-white text-black'
      } rounded-lg w-1/3 p-6`}
      onClick={(e) => e.stopPropagation()}
    >
      <h3 className="text-xl font-semibold mb-4">
        {edit ? 'Edit Task' : 'Assign Task'}
      </h3>
      <form onSubmit={handleTaskSubmit}>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium">Task Name</label>
            <input
              type="text"
              value={task.taskName}
              onChange={(e) => setTask({ ...task, taskName: e.target.value })}
              className={`w-full p-2 border rounded-lg ${
                isDarkMode ? 'bg-gray-700 text-white' : 'bg-white text-black'
              }`}
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Status</label>
            <select
              value={task.taskStatus}
              onChange={(e) => setTask({ ...task, taskStatus: e.target.value })}
              className={`w-full p-2 border rounded-lg ${
                isDarkMode ? 'bg-gray-700 text-white' : 'bg-white text-black'
              }`}
              required
            >
              <option value="" disabled>--Select--</option>
              <option value="Not_Started">Not Started</option>
              <option value="In_Progress">In Progress</option>
              <option value="Complete">Complete</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium">Duration (in days)</label>
            <input
              type="number"
              value={task.duration}
              onChange={(e) => setTask({ ...task, duration: e.target.value })}
              className={`w-full p-2 border rounded-lg ${
                isDarkMode ? 'bg-gray-700 text-white' : 'bg-white text-black'
              }`}
              required
            />
          </div>
          <div className="mt-4 flex justify-between">
            <button
              type="button"
              onClick={handleCloseModal}
              className={`px-4 py-2 ${
                isDarkMode ? 'bg-gray-600 text-white' : 'bg-gray-300 text-black'
              } rounded-lg`}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded-lg"
            >
              {edit ? 'Update Task' : 'Assign Task'}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
)}

    </div>
  );
};

export default UserDetails;
